module.exports = __webpack_public_path__ + "img/total-icon.361eb68c.svg";